const panneauxSandwich = [
  {
    id: "panneaux-bardage-fixation-cachee",
    title: "Panneaux de bardage fixation cachée",
    image: "/assets/images/products/Panneaux de bardage fixation cachée.webp",
    description: "Panneaux sandwich pour façades avec système de fixation invisible",
    longDescription: "Les panneaux de bardage à fixation cachée offrent une solution esthétique et performante pour l'isolation et l'habillage des façades de bâtiments industriels et commerciaux. Leur système d'assemblage innovant dissimule les fixations, garantissant un rendu visuel épuré tout en assurant une parfaite étanchéité et isolation thermique.",
    category: "panneaux_sandwich",
    specifications: [
      "Épaisseur: de 40 à 100mm",
      "Âme isolante en polyuréthane ou laine de roche",
      "Face extérieure en acier prélaqué 0.5mm",
      "Face intérieure en acier prélaqué 0.4mm",
      "Système de joint et fixation invisible",
      "Coefficient thermique: 0.21 à 0.51 W/m²K selon épaisseur",
      "Classement au feu disponible jusqu'à EI 120"
    ]
  },
  {
    id: "panneaux-couverture",
    title: "Panneaux de couverture",
    image: "/assets/images/products/Panneaux de couverture.webp",
    description: "Panneaux sandwich pour toiture avec haute résistance mécanique",
    longDescription: "Les panneaux sandwich de couverture combinent isolation thermique et étanchéité pour les toitures de bâtiments industriels et commerciaux. Leur conception spécifique permet une excellente résistance aux charges climatiques (neige, vent) et une pose rapide grâce au système d'emboîtement optimisé et aux nervures renforcées.",
    category: "panneaux_sandwich",
    specifications: [
      "Épaisseur: de 30 à 150mm",
      "Âme isolante en polyuréthane ou laine de roche",
      "Face extérieure nervurée en acier prélaqué 0.5mm",
      "Face intérieure en acier prélaqué 0.4mm",
      "Pente minimale: 4%",
      "Coefficient thermique: 0.18 à 0.69 W/m²K selon épaisseur",
      "Résistance au feu jusqu'à REI 30"
    ]
  },
  {
    id: "panneaux-froid-bardage",
    title: "Panneaux froid de bardage",
    image: "/assets/images/products/Panneaux froid de bardage.webp",
    description: "Panneaux sandwich spéciaux pour chambres froides et entrepôts frigorifiques",
    longDescription: "Les panneaux sandwich frigorifiques sont spécialement conçus pour la construction de chambres froides et d'entrepôts réfrigérés. Leur composition assure une isolation thermique exceptionnelle, une parfaite étanchéité à la vapeur d'eau et une résistance aux conditions d'utilisation spécifiques des environnements à température contrôlée.",
    category: "panneaux_sandwich",
    specifications: [
      "Épaisseur: de 60 à 200mm",
      "Âme isolante en polyuréthane haute densité",
      "Faces en acier prélaqué avec revêtement alimentaire",
      "Joint d'étanchéité intégré avec système anti-pont thermique",
      "Coefficient thermique: 0.11 à 0.38 W/m²K selon épaisseur",
      "Compatible températures négatives jusqu'à -40°C",
      "Classement au feu B-s2, d0"
    ]
  },
  {
    id: "panneaux-sandwich-laine-de-roche",
    title: "PANNEAUX SANDWICH EN LAINE DE ROCHE",
    image: "/assets/images/products/PANNEAUX SANDWICH EN LAINE DE ROCHE.webp",
    specImage: "PANNEAUX SANDWICH EN LAINE DE ROCHE.webp",
    description: "Panneaux sandwich avec isolation en laine de roche pour haute résistance au feu",
    longDescription: "Les panneaux sandwich en laine de roche offrent une excellente résistance au feu et une isolation thermique et acoustique supérieure. Ils sont idéaux pour les bâtiments où la sécurité incendie est une priorité, comme les établissements recevant du public, les bâtiments industriels à risque ou les entrepôts de stockage sensible.",
    category: "panneaux_sandwich",
    specifications: [
      "Épaisseur: de 50 à 200mm",
      "Âme isolante en laine de roche haute densité",
      "Faces en acier prélaqué 0.5mm",
      "Classement au feu jusqu'à A2-s1, d0",
      "Résistance au feu jusqu'à REI 120",
      "Coefficient thermique: 0.19 à 0.78 W/m²K selon épaisseur",
      "Isolation acoustique renforcée"
    ]
  }
];

export default panneauxSandwich;
